import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Search as SearchIcon, PlaySquare } from 'lucide-react';
import { REELS, getUserById } from '@/shared/data';
import { SmartImage } from '@/shared/ui/SmartImage';

export function Search() {
  const [q, setQ] = useState('');
  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    if (!term) return REELS;
    return REELS.filter((r) => {
      const u = getUserById(r.authorId);
      return r.caption.toLowerCase().includes(term) || u?.username.toLowerCase().includes(term);
    });
  }, [q]);

  return (
    <div data-testid="reelsflix-search" className="h-full overflow-y-auto">
      <div className="px-4 pb-3 pt-3">
        <div className="glass rounded-full flex items-center gap-2 px-4 py-2.5">
          <SearchIcon className="w-4 h-4 text-white/40" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search Reelsflix"
            className="bg-transparent flex-1 outline-none text-sm placeholder:text-white/40"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-[2px]">
        {filtered.map((r) => (
          <Link
            key={r.id}
            to={`/reelsflix?focus=${r.id}`}
            className="relative aspect-[9/16] overflow-hidden bg-black/30"
          >
            <SmartImage fill src={r.poster} alt={r.caption} sizes="50vw" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            <div className="absolute bottom-2 left-2 right-2 text-white/90 text-xs line-clamp-2">
              {r.caption}
            </div>
            <PlaySquare className="absolute top-2 right-2 w-4 h-4 text-white/80" />
          </Link>
        ))}
      </div>
    </div>
  );
}
